import { Link, Text } from "@chakra-ui/react";
import NextLink from "next/link";
import Head from "next/head";
import { PaddedOnMobile } from "@components/site/layout";
import { getServerSession } from "next-auth";
import { createAuthOptions } from "./api/auth/[...nextauth]";
import { GetServerSidePropsContext } from "next";

export const Terms = () => {
    const maxWidth = { base: 450, md: 540 };
    return (
        <>
            <Head>
                <title key="title">Beyond Rarity - Terms</title>
            </Head>
            <PaddedOnMobile
                containerProps={{ maxW: maxWidth, gap: "1.1em", justify: "start", align: "start" }}
                textStyle="site.text"
            >
                <Text textStyle="site.header">Terms of service</Text>
                <Text>
                    Nothing in the site constutues professional and/or financial advice. We will not
                    be held responsible for you moving into your mom&apos;s basement.
                </Text>
                <Text>
                    These Terms of Use (the &quot;Terms&quot;) govern your access to and use of this
                    website, beyondrarity.com (the &quot;Website&quot;), and associated content,
                    software and applications (collectively, the &quot;Service&quot;). These Terms
                    also include our Privacy Policy, which is located at&nbsp;
                    <NextLink shallow href="/privacy" passHref>
                        <Link href="/privacy" textStyle="site.link" color="sorbet">
                            https://Beyondrarity.com/privacy
                        </Link>
                    </NextLink>
                    .
                </Text>
                <Text>
                    The Service of beyondrarity.com is administered and maintained by Kinetic Chain
                    Labs Inc. The terms &quot;we&quot;, &quot;us&quot; and &quot;our&quot; also
                    refer to Beyond Rarity. The term “you” refers to the person visiting this
                    Website.
                </Text>
                <Text>
                    Please read these Terms carefully. They contain important information regarding
                    your legal rights, including limitations on Beyondrarity&apos;s and certain
                    third parties&apos; liability, disclaimers of warranties and a submission to
                    jurisdiction. Each time you access the Service by any means (for example,
                    through the Internet or on a mobile device), you irrevocably agree to comply
                    with the version of the Terms posted on this Website at the time you access this
                    Website. You may not use the Service if you do not agree to these Terms.
                </Text>
            </PaddedOnMobile>
            <PaddedOnMobile
                containerProps={{ maxW: maxWidth, gap: "20px", justify: "start", align: "start" }}
                textStyle="site.text"
            >
                <Text textStyle="site.header">General Terms</Text>
                <Text>
                    Beyond Rarity is an analytics tool currently supporting the Ethereum network,
                    and a really cool community of like-minded individuals who share interests,
                    joys, and challenges of life.
                </Text>
                <Text>
                    Note that because of the nature of the Ethereum network, there is no ability to
                    undo, reverse, or restore any transactions. Owners of NFTs are therefore
                    exclusively responsible for the safety and management of their own private
                    Ethereum wallets. Basically, be super careful!
                </Text>
                <Text>
                    This website and its connected services are provided &quot;as is&quot; and
                    &quot;as available&quot; without warranty of any kind. By using this website,
                    you are accepting sole responsibility for any and all transactions involving
                    NFTs.
                </Text>
                <Text>
                    The Crypto, Metaverse, and NFT space is still the Wild West, and we all have to
                    be extra safe and careful as there are a lot of scammers looking to take
                    advantage of innocent people. And while we strive to make our community and
                    owned properties as safe as humanly possible, we cannot control any actions of
                    third parties outside of our space.
                </Text>
                <Text>
                    Kinetic Chain Labs Inc. does not own or control MetaMask, Google Chrome, the
                    Ethereum network, or any other third-party site, product, or service that you
                    might access, visit, or use for the purpose of enabling you to buy, sell or
                    trade any NFTs.
                </Text>
                <Text>
                    Kinetic chain Labs Inc. will not be liable for the acts or omissions of any such
                    third parties, nor will we be liable for any damage that you may suffer as a
                    result of your transactions or any other interaction with any such third
                    parties, including any direct, indirect, special, incidental, consequential or
                    punitive damages, including but not limited to, personal injury, pain and
                    suffering, emotional distress, loss of revenue, loss of profits, loss of
                    business or anticipated savings, loss of use, loss of goodwill, loss of data,
                    and whether caused by tort (including negligence), breach of contract or
                    otherwise, even if foreseeable.
                </Text>
            </PaddedOnMobile>
            <PaddedOnMobile
                containerProps={{ maxW: maxWidth, gap: "20px", justify: "start", align: "start" }}
                textStyle="site.text"
            >
                <Text textStyle="site.header">Eligibility</Text>
                <Text>
                    To access or use the Service, you must be at least 18 years old. The Service is
                    strictly for your personal, non-commercial use unless you enter into a separate
                    agreement with us for your commercial use. You may not use the Service if we
                    have terminated any account of yours or banned you.
                </Text>
            </PaddedOnMobile>
            <PaddedOnMobile
                containerProps={{ maxW: maxWidth, gap: "20px", justify: "start", align: "start" }}
                textStyle="site.text"
            >
                <Text textStyle="site.header">License</Text>
                <Text>
                    You may only use the Service as expressly permitted by these Terms. All rights
                    not expressly granted to you are reserved by Beyond Rarity, its third-party
                    providers and other respective owners, if any.
                </Text>
                <Text>
                    Beyond Rarity provides content through the Service that is copyrighted and/or
                    trademarked work of Beyond Rarity or Beyond Rarity&apos;s third-party licensors
                    and suppliers (collectively, the &quot;Content&quot;). For clarity, Content
                    shall include all such content accessed by you at any time. You acknowledge that
                    the Service has been developed, compiled, prepared, revised, selected, and
                    arranged by Beyond Rarity and such third parties through the application of
                    methods and standards of judgment developed and applied through the expenditure
                    of substantial time, effort, and money and constitutes valuable intellectual
                    property of Beyond Rarity and such others. Accordingly, you shall protect the
                    proprietary rights of Beyond Rarity and all others having rights in the Service
                    during and after the term of this agreement and comply with all reasonable
                    written requests made by Beyond Rarity to protect its and others&apos;
                    contractual, statutory, and common law rights in the Service.
                </Text>
                <Text>
                    Subject to these Terms, and your compliance with these Terms, Beyond Rarity
                    hereby grants you a limited, personal, non-exclusive, non-sub-licensable and
                    non-transferable license to use the Content and to use this Service, in each
                    case solely for your personal use. You agree not to use the Service or any of
                    the Content for any commercial purpose. Except for the foregoing license, you
                    have no other rights to the Service or any Content, and you may not modify,
                    edit, copy, distribute, reproduce, publish, display, perform, license, sell,
                    rent, lease, loan, create derivative works of, create any index, reverse
                    engineer, alter, enhance, provide access to or in any way exploit the Service or
                    Content in any manner.
                </Text>
                <Text>
                    If you breach any of these Terms, the above license will terminate
                    automatically.
                </Text>
            </PaddedOnMobile>
        </>
    );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    return {
        props: {
            session: await getServerSession(ctx.req, ctx.res, createAuthOptions()),
        },
    };
}

export default Terms;
